﻿import { addNotification, dismissNotification, transformNotification } from '../slices/global-slice';
import { startAppListening } from './listener-middleware';

const notificationTimeouts = new Map<string, number>();

const DEFAULT_EXPIRATION_S = 15;

export function startNotificationListen() {
    startAppListening({
        actionCreator: addNotification,
        effect: async (action, listenerApi) => {
            const state = listenerApi.getState();
            const notification = state.global.notifications[0];

            if (notification && notification.disposeAfterSeconds !== null) {
                // Schedule automatic dismissal
                const timeoutId = self.setTimeout(
                    () => {
                        listenerApi.dispatch(dismissNotification({ id: notification.id }));
                        notificationTimeouts.delete(notification.id);
                    },
                    (notification.disposeAfterSeconds ?? DEFAULT_EXPIRATION_S) * 1000
                );

                notificationTimeouts.set(notification.id, timeoutId);
            }
        }
    });
    startAppListening({
        actionCreator: transformNotification,
        effect: async (action, listenerApi) => {
            const state = listenerApi.getState();
            const notification = state.global.notifications.find((n) => n.id === action.payload.id);
            const existingTimeout = notification ? notificationTimeouts.get(notification.id) : undefined;

            if (notification && notification.disposeAfterSeconds !== null) {
                if (existingTimeout) {
                    self.clearTimeout(existingTimeout);
                    notificationTimeouts.delete(notification.id);
                }
                const timeoutId = self.setTimeout(
                    () => {
                        listenerApi.dispatch(dismissNotification({ id: notification.id }));
                        notificationTimeouts.delete(notification.id);
                    },
                    (notification.disposeAfterSeconds ?? DEFAULT_EXPIRATION_S) * 1000
                );

                notificationTimeouts.set(notification.id, timeoutId);
            }
        }
    });
    startAppListening({
        actionCreator: dismissNotification,
        effect: async (action, listenerApi) => {
            const notificationId = action.payload.id;
            const timeoutId = notificationTimeouts.get(notificationId);

            if (timeoutId) {
                self.clearTimeout(timeoutId);
                notificationTimeouts.delete(notificationId);
            }
        }
    });
}
